"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

var _react2 = require("@emotion/react");

var css = _interopRequireWildcard(require("./ErrorBar.styles"));

var _ = require("../../..");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ErrorBar = function ErrorBar(_ref) {
  var error = _ref.error,
      closeFn = _ref.closeFn;
  var theme = (0, _react2.useTheme)();
  return (0, _jsxRuntime.jsxs)("div", {
    css: css.errorBar,
    children: [theme.name === 'legacy' ? (0, _jsxRuntime.jsx)(_.Icons.WarningCircle, {
      fill: "#B00020",
      css: css.errorIcon
    }) : (0, _jsxRuntime.jsx)(_.Icons.WarningCircleFearless, {
      fill: "#B00020",
      css: css.errorIcon
    }), (0, _jsxRuntime.jsx)("span", {
      css: css.errorText,
      children: error.message
    }), (0, _jsxRuntime.jsx)("button", {
      css: css.closeButton,
      onClick: function onClick() {
        return closeFn();
      },
      type: "button",
      children: theme.name === 'legacy' ? (0, _jsxRuntime.jsx)(_.Icons.DeleteCircle, {
        fill: "#B00020",
        css: {
          width: '16px',
          paddingTop: '3px'
        }
      }) : (0, _jsxRuntime.jsx)(_.Icons.Close, {
        fill: "#B00020",
        css: {
          width: '16px',
          paddingTop: '3px'
        }
      })
    })]
  });
};

var _default = ErrorBar;
exports["default"] = _default;